import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Venue } from '../../../class/venue';
import { VenueService } from '../../../service/venue/venue.service';
import { TranslateService } from '@ngx-translate/core';
import { MapsAPILoader } from '@agm/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';

@Component({
  selector: 'app-new-venue',
  templateUrl: './new-venue.component.html',
  styleUrls: ['./new-venue.component.scss']
})
export class NewVenueComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Venue;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public name: AbstractControl;
    public address: AbstractControl;
    public latitude: number;
    public longitude: number;
    public addressGoogle: string;
    public overlays: any[];
    public selectedPosition: any;
    public activated: AbstractControl;
    public company_id: AbstractControl;
    public companySelected: string;

    @ViewChild('search') public searchElementRef: ElementRef;
    public zoom: number;
    public marker: Marker;


    public filteredCurrencies: any[];
    public filteredTimezones: any[];

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public venueService: VenueService,
        public translate: TranslateService,
        private ngZone: NgZone,
        private notificationsService: NotificationsService,
        private mapsAPILoader: MapsAPILoader) {

        this.save_exit = false;

        this.form = fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'address': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'activated': ['', Validators.compose([Validators.required])],
            'company_id': ['', Validators.compose([Validators.required])]
        });

        this.name = this.form.controls['name'];
        this.address = this.form.controls['address'];
        this.activated = this.form.controls['activated'];
        this.company_id = this.form.controls['company_id'];

        // set google maps defaults
        this.zoom = 2;
        this.latitude = 39.8282;
        this.longitude = -98.5795;

        this.marker = {
            lat: this.latitude,
            lng: this.longitude,
            label: 'Venue',
            draggable: true
        };
    }

    ngOnInit() {
        if (this.edit) {
            this.name.setValue(this.edit.name);
            this.address.setValue(this.edit.address);
            this.activated.setValue(this.edit.activated);
            this.latitude = this.edit.latitude;
            this.longitude = this.edit.longitude;
            this.company_id.setValue(this.edit.company_id);
            if (this.edit.latitude && this.edit.longitude) {
                const lat = this.edit.latitude;
                const lng = this.edit.longitude;
                const position = {
                    lat : lat,
                    lng : lng
                };
                this.setPosition(position);
            }
        } else {
            this.activated.setValue(true);
            this.setCurrentPosition();
        }

        // load Places Autocomplete
        this.mapsAPILoader.load().then(() => {
            const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
                types: ['address']
            });
            autocomplete.addListener('place_changed', () => {
                this.ngZone.run(() => {
                // get the place result
                const place: google.maps.places.PlaceResult = autocomplete.getPlace();

                this.addressGoogle = place.formatted_address;
                // verify result
                if (place.geometry === undefined || place.geometry === null) {
                    return;
                }

                // set latitude, longitude and zoom
                this.latitude = place.geometry.location.lat();
                this.longitude = place.geometry.location.lng();
                this.zoom = 17;
                });
            });
        });
    }

    private setCurrentPosition() {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;
                this.zoom = 17;
            });
        }
    }

    private setPosition(position) {
        this.latitude = position.lat;
        this.longitude = position.lng;
        this.zoom = 17;
    }

    public handleMapClick(event) {
        // this.selectedPosition = event.latLng;
        // this.addMarker(this.selectedPosition.lat(), this.selectedPosition.lng());
    }

    public addMarker(lat, lng) {
        const title = (this.name.value !== '') ? this.name.value : 'venue';
        this.longitude = lng;
        this.latitude = lat;
        this.overlays = [];
        this.overlays.push(
            new google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                }, title: title}
            )
        );
    }

    public cancelVenue () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newVenue(values);
    }

    public newVenue(values: Venue) {
        const param = {
            'name': values.name,
            'address': this.addressGoogle,
            'latitude': this.latitude,
            'longitude': this.longitude,
            'activated': values.activated,
            'company_id': values.company_id
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.venueService.updateVenue(this.edit.id, param)
                :
                this.venueService.newVenue(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                        this.selectedPosition = null;
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    markerDragEnd(m: Marker, $event: any) {
        this.latitude = $event.coords.lat;
        this.longitude = $event.coords.lng;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/venues/new-venue/new-venue.component.ts